// @ts-nocheck
import React from 'react';

import { Container, Row, Col } from 'crehana-ui/GridV2';

import Item from './Item';

import { FAQSection as IFAQSection } from '../../types';

const FAQSection: React.FC<IFAQSection> = ({ title, questions }) => {
  return (
    <section className="bg-base-dark pt-40 pb-80 md:py-64">
      <Container>
        <Row>
          <Col sm={10} md={9}>
            <h2 className="font-h2 mb-32 text-left sm:mb-64 text-white">
              {title}
            </h2>
            <ul>
              {questions.map(el => (
                <Item key={`question-${el.id}`} item={el} />
              ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FAQSection;
